import { tr } from '../i18n/index.js';
// Utilities
import { defineStore } from "pinia";

export const useAppStore = defineStore("app", {
  state: () => {
    return {
      // 根数据
      staff: null, // 全量对象，包含：chain, shops
      shop: null, // name, chain -- changeShop 时获取 全量对象

      //
      loginShop: null, // 登录切换控制，取自 staff.shops[]

      // 公共基础数据
      customerSelected: null, // 会员信息
      orderItem: null, // 取单时的信息 _id
      showMenu: true,
      menuActive: 0, // 激活的一级菜单 index
      tableItem: null, // 桌台订单 _id
      newOrderItem: null, // 新建订单所需要的数据，一般包括会员和商品信息
      unPaidOrder: null, // 待付订单
      scaleConnected: false, //电子秤成功连接
      // 门店类型初始化配置：启动时从 bhserver 获取，页面只读取此运行期缓存。
      shopTypeInits: {},
      shopMenus: {},
    };
  },
  actions: {
    async loadShopTypeInits(baseApiUrl) {
      const response = await fetch(`${baseApiUrl}/config/shopTypeInits`, {
        credentials: "include",
      });
      const data = await response.json();
      if (data.info !== "OK" || !data.inits) {
        throw new Error(data.error || data.info || tr("读取门店初始化配置失败"));
      }
      this.shopTypeInits = data.inits;
    },
    async loadShopMenus(baseApiUrl) {
      const response = await fetch(`${baseApiUrl}/config/menus/shop?receiptStyles=1`, { credentials: "include" });
      const data = await response.json();
      if (data.info !== "OK" || !data.menus) throw new Error(data.error || data.info || tr("读取菜单配置失败"));
      this.shopMenus = data.menus;
    },
  },
});

/** 关于公共基础数据的使用
 *
 * 基础数据主要是为了获取 _id，加上 name 属性为了给人读
 * 不主张携带太多属性数据。属性数据放在数据库中，便于更新和版本升级
 *
 * 基础数据通常用于：
 * 1. 作为 id 供 findOneById 使用，需要时获取完整对象数据
 * 2. 作为 query 的过滤条件
 * 3. 作为标识属性写入文档
 *
 */
